import { customFetch } from 'utils/http';
import { HTTPResponseError, TransactionNotFoundError } from 'utils/errors';
import { M8PaymentTransaction } from 'services/production/types';
import { getM8UserURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  orderId: string;
};

export const getPaymentTransaction = async (
  params: Params
): Promise<M8PaymentTransaction> => {
  const response = await customFetch(
    getM8UserURL(`getPaymentTransaction?${createQueryString(params)}`)
  );

  if (response.ok) {
    return response.json();
  }

  if (response.status === 404) {
    throw new TransactionNotFoundError();
  }

  throw new HTTPResponseError(response);
};
